import React from 'react';

export default function Footer() {
  return (
    <footer className="footer">
      <div>
        © {new Date().getFullYear()} <span className="text-primary">CRYPTOPAY</span> · POWERED BY BSC
      </div>
    </footer>
  );
}
